/**
 * Builds the nested Asset workspace URL under a ticket's Assets tab.
 */
export function getAssetWorkspacePath(input: {
	orgId: string;
	ticketId: string;
	assetId: string;
	tab?: string;
}): string {
	const tab = input.tab ?? "form";
	return `/web/${input.orgId}/tickets/${input.ticketId}/workspace/assets/${input.assetId}/workspace/${tab}`;
}

/**
 * Builds the Asset detail drawer URL for a ticket-scoped asset instance.
 */
export function getAssetDrawerDetailsPath(input: {
	orgId: string;
	ticketId: string;
	assetId: string;
	tab?: string;
}): string {
	const tab = input.tab ?? "details";
	return `/web/${input.orgId}/tickets/${input.ticketId}/workspace/assets/${input.assetId}/${tab}`;
}

/**
 * Builds the nested Record workspace URL under an Asset workspace.
 */
export function getAssetScopedRecordWorkspacePath(input: {
	orgId: string;
	ticketId: string;
	assetId: string;
	recordId: string;
	tab?: string;
}): string {
	const tab = input.tab ?? "form";
	return `/web/${input.orgId}/tickets/${input.ticketId}/workspace/assets/${input.assetId}/workspace/records/${input.recordId}/workspace/${tab}`;
}

/**
 * Builds the Record detail drawer URL under an Asset workspace.
 */
export function getAssetScopedRecordDrawerDetailsPath(input: {
	orgId: string;
	ticketId: string;
	assetId: string;
	recordId: string;
	tab?: string;
}): string {
	const tab = input.tab ?? "details";
	return `/web/${input.orgId}/tickets/${input.ticketId}/workspace/assets/${input.assetId}/workspace/records/${input.recordId}/${tab}`;
}

/**
 * Builds the Asset detail drawer URL nested under a ticket → asset → record
 * workspace Assets tab (`relatedAssetId` is the row asset; `assetId` is the host).
 */
export function getAssetScopedRecordAssetDrawerDetailsPath(input: {
	orgId: string;
	ticketId: string;
	assetId: string;
	recordId: string;
	relatedAssetId: string;
	tab?: string;
}): string {
	const tab = input.tab ?? "details";
	return `/web/${input.orgId}/tickets/${input.ticketId}/workspace/assets/${input.assetId}/workspace/records/${input.recordId}/workspace/assets/${input.relatedAssetId}/${tab}`;
}

/**
 * Builds the Assets tab URL for a record nested under a ticket asset workspace.
 */
export function getAssetScopedRecordAssetsTabPath(input: {
	orgId: string;
	ticketId: string;
	assetId: string;
	recordId: string;
}): string {
	return `/web/${input.orgId}/tickets/${input.ticketId}/workspace/assets/${input.assetId}/workspace/records/${input.recordId}/workspace/assets`;
}

/**
 * Builds the Asset detail drawer URL nested under a ticket → record workspace
 * Assets tab (no host asset).
 */
export function getTicketRecordScopedAssetDrawerDetailsPath(input: {
	orgId: string;
	ticketId: string;
	recordId: string;
	assetId: string;
	tab?: string;
}): string {
	const tab = input.tab ?? "details";
	return `/web/${input.orgId}/tickets/${input.ticketId}/workspace/records/${input.recordId}/workspace/assets/${input.assetId}/${tab}`;
}

/**
 * Builds the Assets tab URL for a record nested under a ticket workspace.
 */
export function getTicketRecordScopedAssetsTabPath(input: {
	orgId: string;
	ticketId: string;
	recordId: string;
}): string {
	return `/web/${input.orgId}/tickets/${input.ticketId}/workspace/records/${input.recordId}/workspace/assets`;
}
